import { render, staticRenderFns } from "./Cocina2.vue?vue&type=template&id=4efef844"
import script from "./Cocina2.vue?vue&type=script&lang=js"
export * from "./Cocina2.vue?vue&type=script&lang=js"
import style0 from "./Cocina2.vue?vue&type=style&index=0&id=4efef844&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports